import { consentForCareProps } from '@usacsmideo/types';

export const ConsentSectionText = (props: consentForCareProps) => {
  return <p className="my-1 text-sm font-semibold">{props.text}</p>;
};
